import {
  Grid,
  Typography,
  WithStyles,
  withStyles,
  CardHeader,
  IconButton,
  Button,
} from "@material-ui/core";
import { RouteComponentProps, withRouter } from 'react-router-dom';
import React, { Component, ReactNode } from "react";
import { connect } from "react-redux";
import { DialogLargeStyle } from "../styles/DialogLargeStyle";

import CloseIcon from '@material-ui/icons/Close';

interface DialogHeaderProps {
  headerTitle: string;
  iconNode: ReactNode;
  urlName: string;
  switchSelectedTab: any;
  setRolesTab: any;
  setUsersTab: any;
  setClientTab: any;
  selectedTab?: any;
  classes: any;
  onSave?: () => void;
  isSaveHidden?: boolean;
  isEditHidden?: boolean;
  onEdit?:()=>void;
  headerCTAName?: string;
}

interface DialogHeaderProps extends WithStyles<typeof DialogLargeStyle>, RouteComponentProps {
  htmlElements: ReactNode;
  classes: any;
  dialogCloseHandler?: () => void;
}
class DialogHeader extends Component<DialogHeaderProps> {
  constructor(props:DialogHeaderProps){
  super();
  }  
  
  dialogCloseHandler = () => {
    const { history, urlName, dialogCloseHandler } = this.props
     if(!dialogCloseHandler) {
      history.push(urlName)
    } else {
      dialogCloseHandler();
    }
  }
  render() {
      const { classes, onSave, isSaveHidden,onEdit,headerCTAName='Save',isEditHidden } = this.props;
    return (
      <>
      <CardHeader
              className={classes.modalHeader}
              action={
                <>
                <div onClick={this.dialogCloseHandler}>
                {this.props.iconNode}
                </div>
                {/* <Link to={this.props.urlName} style={{ textDecoration: 'none' }}
                onClick={this.dialogCloseHandler}
                >
                  {this.props.iconNode}
                </Link> */}
                
                </>
              }
              title={
                <Grid container justify="space-between" alignItems="center">
                  <Grid item>
                <Typography
                  align="left"
                  className={[
                    classes.fontWeight500,
                    classes.dialog_title,
                    classes.fontSizeLG,
                    classes.ellipsis,
                  ].join(' ')}
                >
                  {this.props.headerTitle}
                </Typography>
                </Grid>
                {!isSaveHidden && (
                <Grid item>
                <Button
                    variant="outlined"
                    color="primary"
                    className={classes.saveButon}   
                    onClick={onSave}                                
                  >
                    {headerCTAName}
                  </Button>
                </Grid>
                )}
                  {!isEditHidden && (
                  <Grid item>
                  <Button
                      variant="contained"
                      color="primary"
                      className={classes.saveButon}   
                      onClick={onEdit}                                
                    >
                      Edit
                    </Button>
                  </Grid>
                  )}
                </Grid>
              }
            />
      </>
    );
  }
}
const mapStateToProps = (state: any) => ({
});
const mapDispatchToProps = {
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
    // @ts-ignore
)(withRouter(withStyles(DialogLargeStyle)(DialogHeader)));
